import { AxiosPromise } from "axios";

import { FunderOverview } from "@/modules/funder/types";
import { get } from "@/shared/api/apiInstance";

export default function getFunderOverview(): AxiosPromise<FunderOverview> {
  return get("overview");
}
